import { Component, OnInit } from '@angular/core';
import {EnrollApplicationService} from '../../../../common-main/services/enroll-application.service';

@Component({
  selector: 'app-region-colleges-professions',
  templateUrl: './region-colleges-professions.component.html',
  styleUrls: ['./region-colleges-professions.component.scss']
})
export class RegionCollegesProfessionsComponent implements OnInit {

  professions: any[];
  copyProfessions: any[];
  search: any;
  constructor(private _enrollApplicationService: EnrollApplicationService) { }

  ngOnInit() {
    this._enrollApplicationService.getGSProfessionsByRegion().subscribe(data => {
      this.professions = data;
      this.copyProfessions = data;
    });
  }

  showItemCollegesList(item) {
    item.showColleges =  !item.showColleges;
  }

  searchItems() {
    if (this.search.length > 3) {
      this.professions = this.copyProfessions.filter(item => item.profName.search(this.search) !== -1);
    } else {
      this.professions = this.copyProfessions;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/data/region-colleges-professions/region-colleges-professions.component.ts